"use client";

import { createContext, useContext } from "react";

const TemplateStyleContext = createContext({});

export function TemplateStyleProvider({ value = {}, children }) {
  return (
    <TemplateStyleContext.Provider value={value}>
      {children}
    </TemplateStyleContext.Provider>
  );
}

export function useTemplateComponentClassNames(componentName, themeKey) {
  const templateStyles = useContext(TemplateStyleContext);

  if (!componentName || !themeKey) return {};

  return templateStyles?.[componentName]?.[themeKey] || {};
}
